<template>
    <div>
        <div class="card">
            <div class="card-header">
                <b-button size="sm" variant="primary" @click="addMigracao">Adicionar Migração</b-button>
                <b-button class="ml-3" v-if="perfil == 'adm' || perfil == 'coord_comercial'" size="sm" variant="success"
                    href="/adm/migracao/liberacao">Liberar Migração</b-button>
            </div>
        </div>
        <div class="col-md-12 mt-3">
            <b-table striped hover :items="dataComputed" :fields="colunas">
                <template #cell(actions)="row">
                    <b-button size="sm" @click="show(row.item.id)" variant="primary">
                        <i class="fas fa-eye"></i>
                    </b-button>
                </template>
            </b-table>
            <!-- <v-table :column="colunas" :data="dataComputed"  :actions="actionsTable"  @show='show'></v-table> -->
        </div>

        <!------------------------------------- MODAL DA MIGRACAO DE CLASSE DO DISTRIBUIDOR -------------------------------------------->
        <b-modal title="Migração de classe" v-model="openedModal" size="lg">
            <div class="card">
                <ul class="text-danger">
                    <li v-for="error in errors" :key="error">{{ error }}</li>
                </ul>
                <div class="card-body">
                    <div class="row">
                        <div class="radio-inline">
                            <input type="radio" v-model="migrar_todos" class="radio-inline" :value="true" />
                            <label> Migrar Todas Revendedoras</label>
                            <br>
                            <input type="radio" v-model="migrar_todos" class="radio-inline" :value="false" />
                            <label> Migrar Somente uma Revendedora</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label>Selecione o Distribuidor de origem, pelo qual terá a(s) revendedoras
                                transferidas.</label>
                            <v-select v-model="origem" :options="ObjListaDistribuidor" :disabled="!migrar_todos"
                                :onSearch="getDistribuidor"></v-select>
                        </div>
                    </div>
                    <div class="row" v-show="!migrar_todos">
                        <div class="col">
                            <label class="text-info"> Selecione a Revendedora a ser migrada.</label>
                            <v-select v-model="revendedoras" :options="ObjListaRevendedora" :onSearch="getRevendedoras"
                                @input="selectRevenda" placeholder="Digite o CPF da revendedora">

                            </v-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label>Distribuidor Destino. Distribuidor que irá receber as novas revendedoras.</label>
                            <v-select v-model="destino" :options="ObjListaDistribuidor" :disabled="false"
                                :onSearch="getDistribuidor"></v-select>
                        </div>
                    </div>
                </div>
            </div>
            <template #modal-footer>
                    <b-button variant="primary" size="sm" @click="salvaMigracao">
                        <i class="fas fa-list-ol"></i> Migrar
                    </b-button>
                    <b-button variant="secondary" size="sm" @click="limpaForm">Cancelar</b-button>                
            </template>
        </b-modal>
        <!------------------------------------- RELATORIO COM AS REVENDEDORAS A SEREM MIGRADAS -------------------------------------------->
        <b-modal v-model="openedReport" title="Relatório de Migração de Classe G" size="xl" scrollable>
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Cadastro</th>
                        <th>Endereco </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(list, index) in listaRevendedora" :key="index">
                        <td>{{ list.revendedora }}</td>
                        <td>{{ list.cadastro }}</td>
                        <td>{{ list.endereco }}</td>
                    </tr>
                </tbody>
            </table>
            <template #modal-footer>
                <button type="button" class="btn btn-primary" @click="openedReport = false">Fechar</button>
            </template>
        </b-modal>

    </div>

</template>

<script>
import vSelect from "vue-select";
export default {
    Props: [],
    components: { vSelect },
    data() {
        return {
            datePickerConfig: {
                'format': 'D/MM/YYYY',
                'showClose': true
            },
            modalVisible: false,
            search: "",
            colunas: [
                { key: 'actions', label: "" },
                { key: 'distribuidor_origem', label: 'Origem das Revendedoras' },
                { key: 'distribuidor_destino', label: 'Destino' },
                { key: 'data_migracao', label: 'Data Migração' },
                { key: 'status', label: 'Status' },
                { key: 'usuario', label: 'Solicitante' },
            ],
            data: [],
            origem: "",
            destino: "",
            itensDevolve: [],
            migrar_todos: true,
            listaDistribuidor: [],
            listaRevendedora: [],
            revendedoras: '',
            nomedistribuidor: null,
            distribuidor: null,
            perfil: null,
            status: null,
            errors: [],
            openedModal: false,
            openedReport: false
        }
    },
    methods: {
        getPerfil() {
            const vm = this;
            axios
                .get("/my-profile")
                .then((response) => {
                    vm.perfil = response.data.profile.roles[0].name;
                })
                .catch((erro) => {
                    console.log(erro);
                    alert(erro);
                })
        },
        addMigracao() {
            this.openedModal = true;
        },
        loadDistribuidor: function () {
            let url = '/adm/distribuidores/combo';
            var vm = this;
            axios.get(url).then(function (response) {
                vm.formatSelect(response.data);
            }).catch(function (error) {
                console.log(error);
                $('.loading').hide();
            });
        },
        formatSelect(dataLoaded) {

            var data = [];
            dataLoaded.forEach(function (el, index) {
                let obj = {};
                obj.id = el.id;
                obj.codigo = el.codigo + ' - ' + el.nome;

                data.push(obj);
            });

            this.listaDistribuidor = data;
        },
        loadData() {
            var vm = this;
            // vm.perfil = $('#perfil').val();
            // console.log(vm.perfil);
            axios.get('/adm/migracao/listar').then(function (response) {
                vm.formatDataToTable(response.data)
            }).catch(function (errors) {
                console.log(errors);
                $('.loading').hide();
            });
            //console.log(vm.perfil)

        },
        formatDataToTable(dataLoaded) {

            var data = [];
            var qtd = 0;
            dataLoaded.forEach(function (el, index) {
                let obj = {};
                obj.distribuidor_destino = el.destino.nome;
                obj.distribuidor_origem = el.origem.nome;
                obj.data_migracao = new Date(el.created_at).toLocaleString('pt-BR');
                obj.status = el.status;
                obj.usuario = el.usuario_solicitante;
                obj.id = el.id

                data.push(obj);

            });

            this.data = data;
        },
        show(id) {
            var vm = this;
            var obj = [];

            $('.loading').show();
            axios.get('/adm/migracao/relatorio/' + id).then((response) => {
                obj = response.data;
                vm.listaRevendedora = obj;

            }).catch((errors) => {
                console.log(errors);
                $('.loading').hide();
            });

            //console.log(vm.listaRevendedora);

            $('.loading').hide()
            this.openedReport = true;

        },
        selectRevenda(value) {
            if (typeof value == 'undefined' || value == '') {
                return;
            }

            var vm = this;
            vm.revendedoras = value;
            $('.loading').show();
            axios.get('/adm/migracao/distribuidor/' + value.value).then((response) => {
                let obj = response.data;
                console.log(obj);
                vm.origem = { label: obj.nome, value: obj.id };
                $('.loading').hide();
            }).catch((erro) => {
                console.log(erro);
                console.log(erro.response.data);
                $('.loading').hide();
            });
            $('.loading').hide();
        },
        getRevendedoras(id) {
            if (typeof id == 'undefined' || id == 'undefined' || id == '') {
                console.log('undefined');
                return;
            }
            if (id.length < 6) {
                console.log('cpf curto');
                return;
            }

            var vm = this;
            $('.loading').show();
            axios.get('/adm/migracao/revendedora', { params: { cpf: id } }).then((response) => {
                let obj = response.data;
                vm.listaRevendedora = obj;
                $('.loading').hide();
            }).catch((erro) => {
                console.log(erro);
                console.log(erro.response.data);
                $('.loading').hide();
            });
        },
        getDistribuidor(key) {
            if (typeof key == 'undefined' || key == 'undefined' || key == '') {
                console.log('Distribuidor undefined');
                return;
            }
            var vm = this;
            console.log(key);
            axios.get('/adm/distribuidores/combo', { params: { query: key } }).then((response) => {
                var obj = response.data;
                if (obj.length > 0) {
                    vm.formatSelect(response.data);
                } else {
                    console.log('array vazio...')
                }

            }).catch((error) => {
                console.log(error);
                $('.loading').hide();
            });
        },
        salvaMigracao() {
            var vm = this;
            let url = '/adm/migracao/salva'
            var tp = "";

            let data = {
                origem: vm.origem.value,
                destino: vm.destino.value,
                migrar_todos: vm.migrar_todos,
                revendedora: vm.revendedoras.value
            }
            console.log(data);
            axios.post(url, data).then((response) => {
                let obj = response.data;
                $(".loading").hide();
                vm.$swal('ok', obj.success, 'success');
                vm.limpaForm();
                vm.loadData();
            }).catch((error) => {
                var errors = error.response.data.errors;
                vm.$swal('Ops', errors, 'error')
                $(".loading").hide();
            });

        },
        limpaForm() {
            this.origem = '';
            this.destino = '';
            this.migrar_todos = true;
            this.revendedoras = '';
            this.openedModal = false;
        }

    },
    computed: {
        actionsTable() {
            //console.log(this.data);
            var actions = ['show'];
            return actions;
        },
        ObjListaDistribuidor() {
            var arrayDistribuidor = [];
            this.listaDistribuidor.forEach((item, index) => {
                arrayDistribuidor.push({
                    value: item.id,
                    label: item.codigo
                });
            });
            return arrayDistribuidor;

        },
        ObjListaRevendedora() {
            var arrayRevendedora = [];
            this.listaRevendedora.forEach((item, index) => {
                arrayRevendedora.push({
                    value: item.id,
                    label: item.nome
                });
            });
            return arrayRevendedora;
        },
        filteredData() {
            return this.data.filter(item => {
                return item.id.toLowerCase().indexOf(this.search.toLowerCase()) > -1
            });
        },
        dataComputed() {
            return this.data;
        }
    },

    mounted() {
        this.loadData();
        this.getPerfil();
        //this.loadDistribuidor();
    }

}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// resources/assets/js/components/adm_migracao/List.vue